import { env } from "../config/env";
import type {
  ProductImage
} from "../types/catalog";

function apiBaseUrl(): string {
  return String(
    env.apiUrl
  ).replace(
    /\/$/,
    ""
  );
}

export function productImageUrl(
  imageId: string
): string {
  return `${apiBaseUrl()}/media/product-images/${imageId}`;
}

export function primaryProductImage(
  images: ProductImage[] | undefined
): ProductImage | null {
  if (!images?.length) {
    return null;
  }

  return (
    images.find(
      (image) => image.isPrimary
    ) ??
    images
      .slice()
      .sort(
        (left, right) =>
          left.displayOrder -
          right.displayOrder
      )[0] ??
    null
  );
}
